var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.calculateDuration(_vm.data.item))?_c('span',[_vm._v(" "+_vm._s(_setup.millisecondsToTime(_setup.calculateDuration(_vm.data.item)))+" ")]):(_setup.calculateDuration(_vm.data.item) === 0)?_c('span',[_vm._v(" "+_vm._s(_vm.$t("reporting.durationApproximately"))+" ")]):_c('span',[_vm._v(" --:-- ")])
}
var staticRenderFns = []

export { render, staticRenderFns }